export default {"src":"/_next/static/media/Logomark (1).873104bf.svg","height":48,"width":29,"blurWidth":0,"blurHeight":0};